import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingBag, FaStar } from 'react-icons/fa'; // Import the star icon
import './Dashboard.css';
import { endpoint } from './endpoint';
import CollectionIcon from './collection.svg';
import Notiflix from "notiflix";
import CollectionDisplay from "./CollectionDisplay";
import {useUser} from "./UserContext";
const History = () => {
    const {user} = useUser();
    const [pendingOrders, setPendingOrders] = useState([]);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [ratings, setRatings] = useState({}); // To store ratings for each collection
    const navigate = useNavigate();

    useEffect(() => {
        
            fetch(`${endpoint}/gymapp/getfinishedorders.php?token=${user.token}`)
                .then(res => res.json())
                .then(data => {
                    setPendingOrders(data);

                    // Fetch ratings if included in the order data
                    const initialRatings = data.reduce((acc, order) => {
                        if (order.rating) {
                            acc[order._collectionID] = order.rating;
                        }
                        return acc;
                    }, {});
                    setRatings(initialRatings);
                });
        }
    , [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        navigate('/login');
    };

    const handleViewDetails = (order) => {
        setExpandedOrder(prevState => prevState === order._collectionID ? null : order._collectionID);
    };

    const handleRateService = (orderID, rating) => {
        setRatings(prevRatings => ({
            ...prevRatings,
            [orderID]: rating
        }));

        // Submit the rating to the backend
        fetch(`${endpoint}/gymapp/submitrating.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderID, rating })
        }).then(res => res.json())
          .then(data => {
              if (data.success) {
                  Notiflix.Notify.info('Thank you for your feedback!');
              } else {
                  Notiflix.Notify.failure('Error submitting rating. Please try again.');
              }
          });
    };

    const renderStarRating = (orderID) => {
        const rating = ratings[orderID] || 0; // Current rating, default is 0

        return (
            <div className="star-rating">
                {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar
                        key={star}
                        size={24}
                        color={star <= rating ? '#ffc107' : '#e4e5e9'}
                        onClick={() => handleRateService(orderID, star)}
                        style={{ cursor: 'pointer' }}
                    />
                ))}
            </div>
        );
    };

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <div className="dashboard-container">
            <br/><br/><br/>
            <center>
                <h3>Order History</h3>
                {pendingOrders.length > 0 ? (
                    pendingOrders.map((order) => (
                        <div className="collection-card"  style={{color:"white",background: "linear-gradient(135deg,#033053,#066083)"}} key={order._collectionID}>
                            <img src={CollectionIcon} alt="Collection Icon" />

                            <CollectionDisplay _collectionID = {order._collectionID }/>
                            <div className="collection-status">
                                <b>Status:</b> {order.status}
                            </div>
                            <button onClick={() => handleViewDetails(order)}>
                                {expandedOrder === order._collectionID ? "Hide Details" : "View Details"}
                            </button>
                            {expandedOrder === order._collectionID && (
                                <div className="order-details">
                                    <p><b>Paid:</b> R {order._amount}</p>
                                    <p><b>Bags:</b> {JSON.parse(order._bags).map((bag, index) => (
                                        <span key={index} style={{ marginRight: '10px' }}>
                                            <FaShoppingBag /> {bag}
                                        </span>
                                    ))}</p>
                                    <p><b>Status:</b> {order.status}</p>
                                </div>
                            )}
                            <div className="rate-service">
                                <br/><label>Rate Service: </label>
                                {renderStarRating(order._collectionID)}
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No orders found.</p>
                )}
            </center>
            <br/><br/><br/>
        </div>
    );
};

export default History;
